import React from 'react';

import * as S from './styles';

const SkipToMain = () => <S.Link href="#skip-topnav-target">Skip main navigation</S.Link>;

export default SkipToMain;
